import { useTranslate } from "@refinedev/core";
import { Pill } from "@libertify/ui";

const T_PREFIX = "media.projects.analytics.versions";

export type AllVersionsTagProps = {
  /** The part of the card that counts every version; the whole card by default. */
  part?: "document";
  /** Keeps the tag's space without showing it, so the card doesn't change height. */
  hidden?: boolean;
};

/** Marks a card that counts every version while the page shows one. */
export const AllVersionsTag = ({ part, hidden }: AllVersionsTagProps) => {
  const t = useTranslate();
  return (
    <span
      aria-hidden={hidden}
      style={{ visibility: hidden ? "hidden" : undefined }}
    >
      <Pill tone="primary">
        {t(part === "document" ? `${T_PREFIX}.documentAll` : `${T_PREFIX}.all`)}
      </Pill>
    </span>
  );
};
